export function gotoUrl(url) {
    window.location.href = url;
}

export function hideUserId(userId) {
    if (userId == null || userId.length < 10) {
        return userId;
    }
    
    let result = userId.substr(0,1) + '*****' + userId.substr(7);
    return result;
}